<template>
  <div class="open-class">
    <Head :headerNum="4" />
    <div class="background-div" style="margin-top: 64px">
      <div class="bodyDiv">
        <div class="video-play lf">
          <div class="video-div">
            <video
              controls
              poster="'+data[j].coverUrl+'"
              autoplay="autoplay"
              webkit-playsinline="true"
              playsinline
              x5-playsinline
              x-webkit-airplay="allow"
              :src="selectItem.videoUrl"
              controlsList="nodownload"
              oncontextmenu="return false"
            ></video>
          </div>
          <div class="video-container">
            <span v-if="selectItem.coverUrl"
              ><i>{{ selectItem.title }}</i
              >by {{ selectItem.author }}</span
            >
            <p>{{ selectItem.desc }}</p>
          </div>
        </div>

        <div class="video-list lf">
          <ul class="nav nav-pills divstyletab">
            <li :class="{ active: isActive === 1 }" @click="changeActive(1)">
              <a href="javascript:">讲师课堂</a>
            </li>
            <li :class="{ active: isActive === 2 }" @click="changeActive(2)">
              <a href="javascript:">学员分享</a>
            </li>
          </ul>

          <div class="tab-content">
            <div class="tab-pane fade active in" id="tab11">
              <transition-group enter-active-class="animated fadeIn">
                <div
                  class="tab-list-video"
                  v-for="(item, index) in getList.list"
                  :key="item.id"
                  v-if="item.authorType === isActive"
                  @click="changeVideo(item.id)"
                >
                  <img class="videoImg lf" :src="item.coverUrl" alt="详情" />
                  <div class="contain-con lf">
                    <h3>{{ item.title }}</h3>
                    <span class="video-teacher">
                      <i>{{ item.authorType === 1 ? "讲师" : "学员" }}</i>
                      {{ item.author }}
                    </span>
                    <div class="partake">
                      <img src="/static/img/icon_poeple.png" />
                      <span>{{ item.peopleCount }}人参与</span>
                    </div>
                  </div>
                </div>
              </transition-group>
            </div>
            <div class="tab-pane fade" id="tab12"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="float-img">
      <img class="fl" src="/static/img/ys_kechengguwen.png" alt="课程顾问" />
      <img class="fl" src="/static/img/ys_app.png" alt="羊驼app" />
    </div>
  </div>
</template>

<script>
import ajax from "./../../api/ajax";
import Head from "./../../components/Head";
export default {
  name: "Openclass",
  data() {
    return {
      getList: [], //数据列表
      url: "https://winielts.com", //默认路径
      // urlId:0,
      selectItem: {}, //当前选中数据
      isActive: 1
    };
  },
  components: {
    Head
  },
  methods: {
    changeVideo(id) {
      this.getList.list.forEach(item => {
        if (item.id === id) {
          this.selectItem = item;
        }
      });
    },
    changeActive(flag) {
      this.isActive = flag;
    },
    isHasId() {
      //URL是否含有id
      let domain = window.location.href;
      if (domain.includes("?")) {
        let cha = "";
        let num = 0;
        let chaNum = domain.indexOf("id=");
        cha = domain.substr(chaNum);
        num = cha.replace(/[^0-9]/gi, "");
        num = ~~num;
        console.log(num);
        this.getList.list.forEach(item => {
          if (item.id === num) {
            if (item.authorType === 2) {
              this.isActive = 2;
            }
            this.selectItem = item;
          }
        });
      } else {
        this.selectItem = this.getList.list[0];
      }
    }
  },
  async mounted() {
    const getList = await ajax(
      this.url + "/api/course/listByIds",
      [102, 47, 57, 53],
      "POST"
    );
    this.getList = getList.data;
    console.log(this.getList);
    this.isHasId();
  }
};
</script>

<style scoped lang="stylus">
.partake
  display: flex
  align-items: center
  padding-bottom 10px
  img
    width 12px
    height 12px
  span
    font-size 18px
    color: #666;
    font-size: 14px;
    padding-left: 6px
.open-class{
  width:100%;
  display: block;
  margin:0 auto;
  font-family:"思源黑体";
  padding:0;
  background: #f9f9f9;
  height:100%
}
.background-div{
  width:100%;
  height: 580px;
  display: block;
  margin:0 auto;
  background-color: #4D4D4D;
  padding: 10px 0;
}
.bodyDiv{
  width:1210px;
  height: 560px;
  display: block;
  margin:0 auto;
}
.video-play{
  width: 68.5%;
  background-color: #fff;
  height: 545px;
  display: block;
  margin:0 auto;
}
.video-div{
  margin: 0;
  width: 100%;
  height: 470px;
  overflow: hidden;
  padding: 0;
}
.video-div video{
  width: 100%;
  height: 100%;
  display: block;
  margin: 0 auto;
}
.video-container{
  height: 90px;
  background-color: #333333;
  padding-top: 10px;
}
.video-container span{
  font-family:"思源黑体";
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #ffffff;
}
.video-container span i{
  font-family:"思源黑体";
  font-size: 20px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  font-style: normal;
  margin: 0 3%;
}
.video-container p{
  margin: 1% 3% 0 3%;
  overflow : hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  word-break: break-all;
  font-family:"思源黑体";
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #cccccc;
}
.video-list{
  width: 30.5%;
  height: 560px;
  margin-left: 8px;
  background-color: #333333;
}
.divstyletab{
  margin: 2% 4% 0 4%;
  border-bottom: 1px solid #4C4C4C;
  display: flex;
  align-items: center;
}
.divstyletab li{
  font-family:"思源黑体";
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #808080;
  padding: 10px 15px 10px 15px;
}
.divstyletab.nav-pills > li > a {
  border-radius: 0;
  color: #808080;
  padding: 10px;
}
.divstyletab.nav > li > a:hover, .divstyletab.nav > li > a:focus {
  text-decoration: none;
  background: none;
}
.divstyletab.nav-pills > li.active > a, .divstyletab.nav-pills > li.active > a:hover, .divstyletab.nav-pills > li.active > a:focus {
  color: #ffffff;
  background: none;
  border-bottom: 2px solid #fff;
}
.tab-content{
  padding-top: 5%;
}
.tab-content .tab-pane{
  width: 98%;
}
.tab-content .tab-pane.active{
  height: 470px;
  overflow-y: auto;
}
.tab-content .tab-pane.active::-webkit-scrollbar{/*滚动条整体部分，其中的属性有width,height,background,border等（就和一个块级元素一样）（位置1）*/
  width:10px;
  height:10px;
}
.tab-content .tab-pane.active::-webkit-scrollbar-button{/*滚动条两端的按钮，可以用display:none让其不显示，也可以添加背景图片，颜色改变显示效果（位置2）*/
  display:none;
  background:#404040;
  border-radius:4px;
}
.tab-content .tab-pane.active::-webkit-scrollbar-track{/*外层轨道，可以用display:none让其不显示，也可以添加背景图片，颜色改变显示效果（位置3）*/
  background:#404040;
  border-radius:4px;
}
.tab-content .tab-pane.active::-webkit-scrollbar-track-piece{/*内层轨道，滚动条中间部分（位置4）*/
  background:#404040;
  border-radius:4px;
}
.tab-content .tab-pane.active::-webkit-scrollbar-thumb{/*滚动条里面可以拖动的那部分（位置5）*/
  background:#fff;
  border-radius:4px;
}
.tab-content .tab-pane.active::-webkit-scrollbar-corner {/*边角（位置6）*/
  background:#404040;
  border-radius:4px;
}
.tab-content .tab-pane.active::-webkit-scrollbar-resizer  {/*定义右下角拖动块的样式（位置7）*/
  background:#404040;
  border-radius:4px;
}

.tab-list-video{
  width: 92%;
  display: block;
  margin: 0 auto;
  margin-bottom: 20px;
  height: 74px;
  cursor: pointer;
}
.videoImg{
  width: 36%;
  height: 74px;
  background: #ccc;
  display: inline-block;
}
.contain-con{
  margin-left:3%;
  font-size: 13px;
  flex: 1;
  overflow: hidden;
  width: 61%;
}

.contain-con h3{
  /*margin: 0 0 10px 0;*/
  font-family:"思源黑体";
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #ffffff;
  overflow : hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  word-break: break-all;
}
.contain-con span{
  display: block;
  color: #808080;
  overflow : hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  word-break: break-all;

}
.contain-con .video-teacher{
  color: #0080ff;
  margin: 4px 0;
}
.contain-con span i{
  border: 1px solid #ff3333;
  font-family:"思源黑体";
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #ff3333;
  font-style: normal;
  border-radius: 2px;
  display: inline-block;
  width: 34px;
  height: 18px;
  line-height: 16px;
  text-align: center;
  margin-right: 6px;
}
.contain-con span i.video-textStu{
  border: 1px solid #FF7F00;
  color: #FF7F00;
}
.float-img{
  width:1210px;
  display: block;
  margin:0 auto;
  padding-top: 10px;
}
.float-img img{
  width: 49.5%;
}
.float-img img:nth-child(1){
  margin-right: 10px;
}
@media only screen and (max-width: 1209px) and (min-width: 300px) {
  .bodyDiv{
    width:100%;
  }
  .float-img{
    width: 98%;
    height: 120px;
    margin-bottom: 20px;
  }
  .float-img img{
    width: 49.5%;
  }
  .float-img img:nth-child(1){
    margin-right: 0.5%;
  }
  .float-img img:nth-child(2){
    margin-left: 0.5%;
  }
  .video-container span,.video-container p ,.contain-con h3{
    font-size: 14px;
  }
  .video-container span i{
    font-size: 18px;
  }
  .divstyletab li{
    font-size: 16px;
  }
  .contain-con{
    font-size: 12px;
  }
}
@media only screen and (max-width: 920px) and (min-width: 300px) {
  .background-div {
    width: 100%;
    height: 1130px;
  }
  .bodyDiv{
    width:100%;
  }
  .video-play {
    width: 98%;
    float: none!important;
    height: 545px;
  }
  .video-list {
    width: 98%;
    float: none!important;
    height: 545px;
  }
}
@media only screen and (max-width: 750px) and (min-width: 300px){
  .bodyDiv,.video-play{
    width: 100%!important;
    height: 314px!important;
  }
  .video-div{
    height: 225px!important;
  }
  .background-div {
    height: 868px;
    background-color: #BFBFBF;
    padding: 0;
  }
  .video-list {
    width: 100%;
    margin: 0 auto;
  }
  .float-img {
    width: 98%;
    height: 300px;
    display: block;
    margin: 0 auto;
    margin-bottom: 20px;
  }
  .float-img img{
    width: 100%;
    margin: 0 0 10px 0;
    float: none!important;
  }
  .video-container span i {
    font-size: 16px;
  }
  .video-container span, .video-container p{
    font-size: 12px;
  }
}
@media only screen and (max-width: 420px) and (min-width: 300px){
  .float-img {
    height: 230px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/OpenClass/OpenClass.vue